import Sidebar from 'hb-react/shared/apps/Memberships/components/Sidebar';
import { LockScreen } from 'hb-react/shared/components/LockScreen';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import BillingInformation from './components/BillingInformation';
import Donation from './components/Donation';
import Layout from './components/Layout';
import RegistrationStep from './components/RegistrationStep';
import SuccessStep from './components/SuccessStep';
import { STEPS } from './constants';
import { usePurchaseMembership } from './hooks/usePurchaseMembership';

const PurchaseMembership = ({ displayDocumentTitle }) => {
  const {
    navigation,
    currentStep,
    currentPage,
    memberships,
    eligibleForPromocodes,
    addons,
    cart,
    donations,
    cartItems,
    withPayment,
    registrationSubmitButtonText,
    goToRegistrationStep,
    goToMembershipIndexPage,
    onBillingComplete,
    onMembershipUpdate,
    onRegistrationComplete,
    onDonationSubmit,
    onDonationClose,
    donationOverlayHeadline,
  } = usePurchaseMembership();
  const { flagEvOrderSummaryDsMemberships } = useFeatureFlag();

  return (
    <Layout
      navigation={navigation}
      sidebar={
        <Sidebar
          cartItems={cartItems}
          memberships={memberships}
          currentStep={currentStep}
          topBoundary="header"
          offset={flagEvOrderSummaryDsMemberships ? '20px' : '25px'}
          eligibleForPromocodes={eligibleForPromocodes}
        />
      }
      currentPage={currentPage}
    >
      {currentStep === STEPS.REGISTRATION_COMPLETED && <LockScreen />}
      <Page
        currentPage={currentPage}
        currentStep={currentStep}
        displayDocumentTitle={displayDocumentTitle}
        withPayment={withPayment}
        memberships={memberships}
        addons={addons}
        cart={cart}
        onMembershipUpdate={onMembershipUpdate}
        goToRegistrationStep={goToRegistrationStep}
        onBillingComplete={onBillingComplete}
        onRegistrationComplete={onRegistrationComplete}
        goToMembershipIndexPage={goToMembershipIndexPage}
        registrationSubmitButtonText={registrationSubmitButtonText}
      />

      {currentStep === STEPS.DONATIONS && (
        <Donation
          header={donationOverlayHeadline}
          donations={donations}
          opened
          onSubmit={onDonationSubmit}
          onClose={onDonationClose}
        />
      )}
    </Layout>
  );
};

const Page = ({
  currentPage,
  displayDocumentTitle,
  withPayment,
  onMembershipUpdate,
  goToRegistrationStep,
  goToMembershipIndexPage,
  onBillingComplete,
  onBillingSuccess,
  onRegistrationComplete,
  memberships,
  addons,
  registrationSubmitButtonText,
}) => {
  if (currentPage === STEPS.BILLING) {
    return (
      <>
        {displayDocumentTitle(__('Billing info'))}
        <BillingInformation
          memberships={memberships}
          onBack={goToRegistrationStep}
          onSubmit={onBillingComplete}
          onSuccess={onBillingSuccess}
          withPayment={withPayment}
        />
      </>
    );
  }

  if (currentPage === STEPS.SUCCESS) {
    return <SuccessStep memberships={memberships} />;
  }

  return (
    <>
      {displayDocumentTitle(__('Registration'))}
      <RegistrationStep
        onCancel={goToMembershipIndexPage}
        onMembershipUpdate={onMembershipUpdate}
        addons={addons}
        memberships={memberships}
        registrationSubmitButtonText={registrationSubmitButtonText}
        onNext={onRegistrationComplete}
      />
    </>
  );
};

export default PurchaseMembership;
